/* src/app/employee-validation/employee-validation-presenter/employee-validation-presenter.component.scss */
body#themeTag :host ::ng-deep .p-tabview .p-tabview-panels {
  padding: 0.5em !important;
}
body#themeTag :host ::ng-deep .p-tabview-nav-link:hover {
  background-image: linear-gradient(rgba(184, 218, 255, 0.5019607843), white);
}
body#themeTag :host ::ng-deep .p-tabview-nav-link.p-ripple {
  background-color: transparent;
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
  width: 9.3em;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-bottom: 0;
}
.activeTab {
  background-color: rgba(184, 218, 255, 0.5019607843);
}
.activeTab .management-tabulator .tabulator-arrow {
  display: none;
}
/*# sourceMappingURL=employee-validation-presenter.component.css.map */
